<script setup>
import Card from '@/components/Card.vue'
import Button from "@/components/Button.vue";
import { computed, defineProps } from 'vue'
import {useAccessMethodUtils} from "@/Modules/Access/composables/accessMethodUtils";

const { getAccessMethod } = useAccessMethodUtils()

const props = defineProps({
  cardClasses: String,
  method: {
    type: Object,
    required: true
  },
  showRemoveBtn: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
    required: true
  },
  onPress: Function,
  onPressRemove: Function,
})

const methodData = computed(() => getAccessMethod(props.method?.name))

</script>

<template>
  <Card @click.prevent.stop="onPress(method)" class="card border border-gray-300 shadow-sm rounded-sm h-50px p-0 w-100" :class="cardClasses">
    <div class="d-flex flex-row rounded-sm h-100">
      <div class="bg-gray-300 h-100 w-50px d-flex align-items-center justify-content-center">
        <button class="btn btn-sm btn-icon bg-gray-500">
          <i class="fa fs-3 text-white" v-html="methodData?.icon"></i>
        </button>
      </div>
      <div class="d-flex align-items-center p-5">
        {{ methodData.name }}
      </div>
      <div v-if="showRemoveBtn" class="ms-auto h-100 w-50px d-flex align-items-center justify-content-center">
        <button @click.prevent.stop="onPressRemove(index)" class="btn btn-sm btn-icon border border-danger bg-hover-danger text-hover-white">
          <i class="fa fa-trash text-danger text-hover-white"></i>
        </button>
      </div>
    </div>
  </Card>
</template>

<style scoped>

</style>